module.exports = __webpack_public_path__ + "img/m-trd.dfa92dc3.svg";